import { useState } from "react";
import type { FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { categories } from "@/mocks/news";

const mainNav = [
  { label: "首页", to: "/" },
  { label: "社会", to: "/category/society" },
  { label: "娱乐", to: "/category/entertainment" },
  { label: "财经", to: "/category/finance" },
  { label: "科技", to: "/category/tech" },
  { label: "民生", to: "/category/livelihood" },
  { label: "体育", to: "/category/sports" },
  { label: "全部爆料", to: "/category/all" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    setMobileOpen(false);
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const linkBase = "whitespace-nowrap text-sm font-medium transition-colors";

  return (
    <header className="sticky top-0 z-40 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="hidden border-b border-background-200/70 bg-background-100 md:block">
        <div className="mx-auto flex h-9 max-w-[1280px] items-center justify-between px-4 md:px-6 text-xs text-foreground-500">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-time-line text-primary-500" />
              2026年10月14日 星期三
            </span>
            <span className="hidden lg:inline text-foreground-400">权威 · 及时 · 真实 · 独立核实</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-primary-600">
              关于我们
            </Link>
            <Link to="/contact" className="transition-colors hover:text-primary-600">
              联系我们
            </Link>
            <Link
              to="/contact"
              className="flex items-center gap-1 text-accent-600 transition-colors hover:text-accent-700"
            >
              <i className="ri-megaphone-line" />
              我要爆料
            </Link>
          </div>
        </div>
      </div>

      <div className="mx-auto flex h-16 max-w-[1280px] items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-label text-lg font-extrabold text-background-50">
            51
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
              爆料网
            </span>
            <span className="mt-0.5 text-[10px] font-medium uppercase tracking-[0.2em] text-primary-500">
              News Portal
            </span>
          </span>
        </Link>

        <nav className="hidden flex-1 items-center gap-6 lg:flex">
          {mainNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `${linkBase} ${
                  isActive
                    ? "text-primary-600"
                    : "text-foreground-700 hover:text-primary-600"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-3">
          <form onSubmit={handleSearch} className="hidden items-center md:flex">
            <div className="flex h-10 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 focus-within:border-primary-400 focus-within:bg-background-50">
              <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base" />
              </span>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索爆料、热点、关键词…"
                className="w-40 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400 xl:w-52"
              />
            </div>
          </form>

          <button
            type="button"
            aria-label="展开菜单"
            onClick={() => setMobileOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-300 text-foreground-700 lg:hidden"
          >
            <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="px-4 py-4 md:px-6">
            <form onSubmit={handleSearch} className="mb-4">
              <div className="flex h-11 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4">
                <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                  <i className="ri-search-line text-base" />
                </span>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索爆料、热点、关键词…"
                  className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
                />
              </div>
            </form>

            <p className="mb-2 text-xs font-semibold text-foreground-400">爆料分类</p>
            <div className="mb-4 grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center gap-2 rounded-lg border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-800"
                >
                  <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className={cat.icon} />
                  </span>
                  {cat.name}
                </Link>
              ))}
            </div>

            <div className="grid grid-cols-2 gap-2 border-t border-background-200 pt-4">
              <Link
                to="/category/all"
                onClick={() => setMobileOpen(false)}
                className="rounded-lg bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
              >
                全部爆料
              </Link>
              <Link
                to="/about"
                onClick={() => setMobileOpen(false)}
                className="rounded-lg border border-background-300 px-3 py-2.5 text-center text-sm font-medium text-foreground-800"
              >
                关于我们
              </Link>
              <Link
                to="/contact"
                onClick={() => setMobileOpen(false)}
                className="col-span-2 rounded-lg border border-background-300 px-3 py-2.5 text-center text-sm font-medium text-foreground-800"
              >
                联系我们 / 我要爆料
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}